module.exports = __webpack_public_path__ + "static/media/luchador.b813d55b.svg";